export const DIALOG_TITLES = {
  ASK_LOGOUT: '로그아웃 하시겠어요?',
  ASK_LEAVE_WORK: '퇴근하시겠어요?',
  ASK_CHECK_OUT: '체크아웃하시겠어요?',
  ASK_WITHDRAW_ACCOUNT: '탈퇴하시겠어요?',
  ASK_CANCEL_SPECIAL_MEDICAL_SUBMIT: '제출을 취소하시겠어요?',
  ASK_CHECK_OUT_SAME_GONGJEONG: '같은 공정을 스캔했어요',
  COMPLETED_LEAVE_WORK: '오늘도 함께해주셔서 감사해요',
  COMPLETED_LEAVE_EARLY: '조퇴했어요',
  COMPLETED_REGISTER_ACCOUNT: '회원가입을 완료했어요',
  COMPLETED_CHANGE_PHONE_NUMBER: '휴대폰 번호가 변경됐어요',
  COMPLETED_REQUEST_WORK_PLAN: '근무 등록을 요청했어요',
  EXPIRED_VERIFICATION_CODE: '인증번호가 만료됐어요',
  NEED_TO_CHANGE_PASSWORD: '비밀번호를 변경해주세요.',
  EXPIRED_PASSWORD: '비밀번호 초기화를 진행해주세요',
  EXPIRED_TOKEN: '로그인 인증 만료',
  EXPIRED_CONTRACT_STATUS: '지금은 출근할 수 없어요',
  INVALID_QR_CODE: '유효한 공정 QR 코드가 아니에요',
  INCORRECT_VERIFICATION_CODE: '인증번호가 일치하지 않아요',
  INCORRECT_ADMIN_CODE: '관리자 확인 코드가 올바르지 않아요',
  FAILED_RESEND_VERIFICATION_CODE: '잠시 후 다시 시도해주세요',
  FAILED_UPLOAD_IMAGE_SIZE_LARGE: '파일 용량이 너무 커요',
  FAILED_UPLOAD_IMAGE_LOAD_ERROR: '파일 로드에 실패했어요',
  FAILED_CHECK_IN: '지금은 체크인할 수 없어요',
  FAILED_IMPOSSIBLE_TO_WORK: '해당 사항이 있는 경우 근무가 어려워요',
  FAILED_SELF_CERTIFICATE_MISMATCH_INFO: '인증 정보가 계약 체결 정보와 일치하지 않아요',
  FAILED_SELF_CERTIFICATE_TIME_OUT: '인증 시간이 만료됐어요',
  FAILED_SELF_CERTIFICATE_FOREIGNER_NOT_SUPPORTED: '외국인 본인인증은 지원하지 않아요',
  FAILED_CHANGE_PASSWORD_NOT_ALLOWED: '아직 비밀번호를 변경할 수 없어요',
  MISMATCH_PHONE_NUMBER_WITH_LOGIN_ID: '입력하신 휴대폰 번호로 등록된 정보가 없어요',
  NOT_FOUND_LOGIN_ID: '일치하는 계정을 찾지 못했어요',
};

export const DIALOG_MESSAGES = {
  ASK_WITHDRAW_ACCOUNT: '탈퇴 시 자동으로 로그아웃돼요.',
  ASK_CANCEL_SPECIAL_MEDICAL_SUBMIT: '제출했던 정보가 사라져요.',
  ASK_LEAVE_WORK: '체크인 상태인 경우 자동 체크아웃돼요.',
  ASK_CHECK_OUT: '현재 공정에서 체크아웃돼요.',
  ASK_CHECK_OUT_SAME_GONGJEONG: '같은 공정을 다시 스캔하면 체크아웃됩니다.\n체크아웃하시겠어요?',
  COMPLETED_LOGOUT: '로그아웃이 완료됐어요.',
  COMPLETED_LEAVE_EARLY: '10시간 후 다시 출근할 수 있어요.',
  COMPLETED_REGISTER_ACCOUNT: '로그인 화면으로 이동할게요.',
  COMPLETED_CHANGE_PHONE_NUMBER: '내 정보 관리 화면으로 이동할게요.',
  COMPLETED_REQUEST_WORK_PLAN: '관리자 승인 후 등록돼요.',
  EXPIRED_TOKEN: '로그인 인증 유효시간이 만료되었습니다.\n이전 작업이 처리되지 않았으니 \n재 로그인 후 확인해 주세요.',
  EXPIRED_CONTRACT_STATUS: '근로계약 시간이 만료되어 출근할 수 없어요.',
  EXPIRED_VERIFICATION_CODE: '재발송 버튼을 눌러 다시 인증해주세요.',
  FAILED_RESEND_VERIFICATION_CODE: '발송 1분 뒤부터 재발송할 수 있어요.',
  FAILED_UPLOAD_IMAGE_SIZE_LARGE: '10MB 이하의 파일을 선택해주세요.',
  FAILED_UPLOAD_IMAGE_LOAD_ERROR: '예기치 못한 에러가 발생했어요. 다시 시도해주세요.',
  FAILED_IMPOSSIBLE_TO_WORK: '컬리 채용팀에 문의해주세요.',
  FAILED_CHANGE_PASSWORD_NOT_ALLOWED: '비밀번호는 변경 후 24시간이 지나야 다시 변경할 수 있어요.',
  INVALID_QR_CODE: '올바른 공정 QR 코드를 스캔해주세요.',
  SHOULD_CHANGE_PASSWORD: '개인정보 보호를 위해 비밀번호를 변경해주세요.',
  NEED_TO_CHANGE_PASSWORD: '개인정보 보호를 위해 90일마다 변경해야 해요.',
};

export const TOAST_MESSAGES = {
  CHANGE_PASSWORD_NEXT_TIME: '30일 후 다시 안내해드릴게요.',
  COMPLETED_CONTRACT: '계약을 완료했어요. 작성한 계약서는 계약서 관리 메뉴에서 확인해 주세요.',
  COMPLETED_CHECK_OUT: '체크아웃했어요.',
  COMPLETED_CHANGE_GONGJEONG: '공정을 변경했어요.',
  COMPLETED_SAFETY_EDUCATION: '안전교육을 이수했어요.',
  COMPLETED_REGISTER_CONTRACT_INFO: '계약 체결 정보를 등록했어요.',
  COMPLETED_REGISTER_CONTRACT_WORK_INFO: '근무 정보를 등록했어요.',
  COMPLETED_SEND_VERIFICATION_CODE: '인증번호를 보냈어요.',
  COMPLETED_SET_NEW_PASSWORD: '비밀번호를 변경했어요. 다시 로그인해주세요.',
  COMPLETED_CHANGE_PASSWORD: '비밀번호를 변경했어요.',
  COMPLETED_MODIFY_USER_INFO: '내 정보를 변경했어요.',
  COMPLETED_WITHDRAW_ACCOUNT: '탈퇴가 완료됐어요.',
  COMPLETED_SUBMIT_SPECIAL_MEDICAL: '검진 확인서를 제출했어요.',
  COMPLETED_DOWNLOAD_PAY_STATEMENT: '급여명세서가 사진첩에 저장되었습니다.',
  FAILED_UPLOAD_CONTRACT_SIGN_IMAGE: '계약서 서명 제출에 실패하였습니다',
  FAILED_LOAD_CAMERA: '카메라 로드 중 실패했어요. 다시 시도해주세요.',
  FAILED_LOAD_GALLERY: '사진첩 로드 중 실패했어요. 다시 시도해주세요.',
  FAILED_CHECK_CAMERA_RESULT: '촬영된 사진을 확인할 수 없어요.',
  FAILED_LOAD_IMAGE: '이미지 로드 중 실패했어요. 다시 시도해주세요.',
  FAILED_DOWNLOAD_PAY_STATEMENT: '급여명세서 다운로드 중 오류가 발생했습니다. 관리자에게 문의해주세요.',
  FAILED_CHECK_CONTRACTED_DATE: '상용직 근무 시작일을 확인할 수 없어요. 관리자에게 문의해주세요.',
  UNABLE_TO_SELECT_WORK_PART: '선택 가능한 업무 파트가 없어요. 관리자에게 문의해주세요.',
  UNABLE_TO_SELECT_TEAM_NAME: '선택 가능한 팀이 없어요. 관리자에게 문의해주세요.',
  UNABLE_TO_SELECT_CENTER_SHIFT_HOUR_TYPE: '선택 가능한 근무조가 없어요. 관리자에게 문의해주세요.',
  INVALID_DATE_RANGE_EMPTY_START_DATE: '시작일을 선택해주세요.',
  INVALID_DATE_RANGE_EMPTY_END_DATE: '종료일을 선택해주세요.',
  INVALID_KURLYRO_NETWORK: '컬리로 네트워크에 연결해주세요.',
  INVALID_PHONE_NUMBER_INCLUDING_DOT: '휴대폰 번호에 .이 포함되어 있어요.',
  INVALID_SPECIAL_MEDICAL_CONTRACT_POINT_NUMBER: '상담 번호가 유효하지 않아요. 관리자에게 문의해주세요.',
  INVALID_SPECIAL_MEDICAL_COUNSELING_LINK: '상담 예약 링크가 유효하지 않아요. 관리자에게 문의해주세요.',
  INVALID_CONTRACTED_DATE: '상용직 근무 시작일 이후의 근무만 등록할 수 있어요.',
  EMPTY_EXAMINATION_DATE: '검진 일자를 선택해주세요.',
};

export const HELPER_TEXT = {
  REQUIRED_SAME_PASSWORD: '동일한 비밀번호를 입력해주세요',
  REQUIRED_NAME: '이름을 입력해주세요',
  REQUIRED_ID: '아이디를 입력해주세요',
  REQUIRED_PASSWORD: '비밀번호를 입력해주세요',
  REQUIRED_VERIFICATION_CODE: '인증번호를 입력해주세요',
  REQUIRED_PHONE_NUMBER: '휴대폰 번호를 입력해주세요',
  REQUIRED_IDENTIFICATION_NUMBER: '주민등록번호를 입력해주세요',
  REQUIRED_POST_CODE: '우편번호를 검색해주세요',
  REQUIRED_ADDRESS: '주소를 입력해주세요',
  REQUIRED_BANK_NAME: '은행명을 선택해주세요',
  REQUIRED_CENTER: '센터를 선택해주세요',
  REQUIRED_TEAM_NAME: '팀명을 선택해주세요',
  REQUIRED_WORK_SHIFT_TYPE: '근무조를 선택해주세요',
  REQUIRED_WORK_PART: '업무파트를 선택해주세요',
  REQUIRED_ACCOUNT_NUMBER: '계좌번호를 입력해주세요',
  REQUIRED_REQUEST_REASON: '사유를 입력해주세요',
  INFO_ID_CONDITION: '3~15자의 영문 또는 영문+숫자를 사용해주세요',
  INFO_REGISTER_ID_CONDITION: '3~15자의 영문 또는 영문+숫자를 사용해주세요',
  INFO_PASSWORD_CONDITION: '8~15자의 영문+숫자+특수문자(공백 제외)를 사용해주세요',
  INFO_NEW_PASSWORD_CONDITION: '동일한 비밀번호를 입력해주세요',
  INFO_LOGIN_PASSWORD_CONDITION: '영문, 숫자, 특수문자 조합 8자리 이상',
  INFO_NAME_CONDITION: '10자 이내의 한글 또는 영문만 사용해주세요',
  INFO_IDENTIFICATION_NUMBER_CONDITION: '-를 제외한 13자리 숫자로 입력하세요',
  INFO_ACCOUNT_NO_LIMIT: '계좌번호는 6자리 이상 숫자여야 합니다',
  INFO_COMMUTE_WORK_SHIFT: '근무조가 보이지 않는 경우 관리자에게 문의해주세요.',
  INFO_COMMUTE_WORK_TYPE: '근무 유형은 JADE에서 신청 또는 변경할 수 있어요.',
  INVALID_PHONE_NUMBER: '휴대폰 번호를 정확히 입력해주세요',
};

export const PLACEHOLDER_TEXT = {
  LABEL_ID: '아이디',
  LABEL_PASSWORD: '비밀번호',
  SELECT: '선택',
  ID: '아이디 입력',
  PASSWORD: '비밀번호 입력',
  CHECK_PASSWORD: '비밀번호 재입력',
  CURRENT_PASSWORD: '현재 비밀번호 입력',
  POST_CODE: '우편번호를 검색해주세요',
  ADDRESS: '우편번호 검색 시, 자동 입력됩니다',
  DETAIL_ADDRESS: '건물, 아파트, 동/호수 입력',
  BANK_NAME: '은행/증권사 선택',
  ACCOUNT_NUMBER: '계좌번호 입력',
  RULE_ID: '3~15자 영문 또는 영문+숫자',
  RULE_NAME: '10자 이내 한글 또는 영문',
  RULE_PASSWORD: '8~15자 영문+숫자+특수문자(공백 제외)',
  RULE_PHONE_NUMBER: '숫자만 입력',
  RULE_ADMIN_CODE: '숫자만 입력',
  RULE_IDENTIFICATION_NUMBER: '숫자만 입력',
  RULE_VERIFICATION_CODE: '인증번호 6자리',
  RULE_REQUEST_REASON: '60자 내로 작성해주세요.',
};

export const BOTTOM_SHEET_TITLES = {
  SELECT_CLUSTER: '클러스터를 선택해주세요',
  SELECT_CENTER: '센터를 선택해주세요',
  SELECT_WORK_PART: '업무파트를 선택해주세요',
  SELECT_TEAM_NAME: '팀을 선택해주세요',
  SELECT_CENTER_SHIFT_HOUR_TYPE: '근무조를 선택해주세요',
  SELECT_OVER_WORK_WISHED_STATUS: '연장 근무 희망 여부를 선택해주세요',
  SELECT_BANK_NAME: '은행 또는 증권사를 선택해주세요',
  CONFIRM_CONTRACT_WORK_INFO: '근무 정보를 확인해주세요',
  REGISTER_CONTRACT_USER_INFO: '계약 체결 정보를 등록할게요',
  REGISTER_CONTRACT_WORK_INFO: '근무 정보를 등록할게요',
  ASK_GUIDE_BEFORE_REGISTER: '가입 전 물류센터 근무 신청을 하셨나요?',
  ASK_GUIDE_BEFORE_REGISTER_SUBTITLE: '신청하지 않으셨다면 각 센터별 근무 안내를 확인해주세요',
  ASK_VERIFICATION_CODE_DELIVERY: '인증번호를 못 받으셨나요?',
  ASK_WANT_TO_OVER_TIME_WORK: '금일 연장 근무를 희망하시나요?',
  ASK_WANT_TO_LEAVE_EARLY: '조퇴하시겠어요?',
  ASK_INCORRECT_CONTRACT: '잘못 계약하셨나요?',
  DATE_PICKER_FOR_EXAMINATION_DATE: '검진 일자',
  SIGN_CONTRACT: '계약서에 서명해주세요',
  UPLOAD_SPECIAL_MEDICAL_EXAMINATION: '검진 확인서 첨부',
  POLICY_AGREE: '이용 약관 동의',
  POLICY_AGREE_SUBTITLE:
    '더 나은 컬리로 서비스 제공을 위해 일부 약관이 변경되었어요. 원활한 앱 사용을 위해 업데이트된 개인정보 수집 이용에 동의해주세요. (개인정보 보호법 제 15조 참조)',
};

export const GUIDE_TITLES = {
  ASK_CAUTION_IMPOSSIBLE_TO_WORK: '아래 내용 중 해당 사항이 있나요?',
  SPECIAL_MEDICAL_TARGET_USER: '특수건강검진 대상자 문자를 받은 경우만 제출해주세요.',
  SPECIAL_MEDICAL_REJECTED_USER: '반려 사유를 확인 후 다시 제출해주세요.',
  SPECIAL_MEDICAL_SECOND_EXAMINATION_TARGET_USER: '2차 검진 대상자입니다.',
  SPECIAL_MEDICAL_COUNSELING_TARGET_USER: '상담 대상자입니다.',
};

export const GUIDE_MESSAGES = {
  ASK_VERIFICATION_CODE_DELIVERY: '인증번호를 못 받으셨나요?',
  ASK_INCORRECT_CONTRACT: '계약서를 다시 작성해야해요. 관리자에게 문의 후 새로고침해주세요.',
  ASK_WANT_TO_LEAVE_EARLY: '조퇴 후 철회는 관리자에게 문의해주세요.',
  VERIFICATION_CODE:
    '통신사 스팸 또는 1644-1107 번호가 차단되어 있는지 확인해주세요.\n카카오톡 앱이 설치되어 있는지 확인해주세요.\n카카오톡 계정이 없으면 문자로 발송돼요.',
  ASK_CAUTION_IMPOSSIBLE_TO_WORK: '해당 사항이 있는 경우 근무가 어려워요.',
  CAUTION_FOR_PREGNANT_USER:
    '임산부는 임신중인 여성, 산후 1년 이내이신 분들을 포함합니다.\n임산부는 법에서 금지하는 직종 (근로기준법 제64조) 고열작업 및 한랭작업, 중량물을 취급하는 근로가 불가능합니다.\n임산부는 시간외 근로가 불가합니다. (근로기준법 제74조5항)\n임산부는 예외 조건을 제외한 경우에는 야간근로 및 휴일근로가 금지됩니다. (근로기준법 제70조)',
  CONTRACT_WORK_INFO: '근무 정보를 정확히 선택해야 급여가 정상적으로 지급돼요.',
  CONTRACT_USER_INFO_NOT_CHANGED: '아래 등록된 정보 중 변경 사항이 있으면 수정해주세요.',
  CONTRACT_USER_INFO_CHANGED: '변경 사항을 입력 후 저장해주세요.',
  PAY_STATEMENT_FOR_ETC: '주휴/특근/프로모션/연차의 급여명세서입니다.',
  SPECIAL_MEDICAL_TARGET_USER: '제출 후에는 관리자 승인 대기 상태로 변경돼요.',
  SPECIAL_MEDICAL_SECOND_EXAMINATION_TARGET_USER: '검진 병원 예약 신청을 진행해주세요.',
  SPECIAL_MEDICAL_COUNSELING_TARGET_USER: '상담 예약 버튼으로 건강\u00A0상담을\u00A0예약해주세요.',
  SPECIAL_MEDICAL_POLICY_TABLE_DESCRIPTION:
    '특수건강진단 이력 관리를 위해서 필요한 최소한의 개인정보입니다. 동의를 해 주셔야 특수건강진단 이력을 등록하실 수 있으며, 동의하지 않으실 경우 비용 지원에 제한이 있을 수 있습니다.',
  SHORT_EMPTY_TIME_LINE: '근무 이력이 없어요',
  CONTRACT_EMPTY_WORK_PLAN: '등록된 근무 계획이 없어요.',
  CONTRACT_EMPTY_RECORDED_WORK_TIME_LINE: '근무한 기록이 없어요.\n누락됐다면 근무를 등록해주세요.',
  EMPTY_CONTRACT_SIGN: '여기에 서명해주세요',
  EMPTY_LIST: '조회 결과가 없어요',
  EMPTY_PAY_STATEMENT: '해당 날짜의 급여명세서가 없어요',
  EMPTY_COMPLETED_CONTRACT: '체결된 계약이 없어요',
  EMPTY_CANCELED_CONTRACT: '취소된 계약이 없어요',
  INVALID_PATH: '정상적인 경로의\\n접근이 아니에요',
  ONLY_PERSONAL_BANK_ACCOUNT: '본인 명의 계좌만 등록할 수 있어요.',
  VERIFY_PASSWORD: '회원 정보 보호를 위해 비밀번호를 입력해주세요.',
  REGISTER_NAME_DESCRIPTION: '본인 확인을 위해 반드시 실명을 입력해 주세요.',
};
